import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgLinesPencil(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.75 5.75H30.25V8.25H1.75V5.75ZM25.3055 10.75C25.6378 10.7494 25.9566 10.8811 26.1916 11.1161L29.8839 14.8084C30.1189 15.0434 30.2506 15.3623 30.25 15.6945C30.2494 16.0268 30.1165 16.3452 29.8807 16.5794L27.0623 19.3777L27.0755 19.391L25.3014 21.1524L25.2882 21.1391L18.3936 27.9845C18.2195 28.1573 17.9985 28.2751 17.758 28.3232L13.2452 29.2257C12.8353 29.3077 12.4117 29.1794 12.1161 28.8839C11.8206 28.5884 11.6923 28.1647 11.7743 27.7549L12.6769 23.242C12.725 23.0015 12.8427 22.7805 13.0155 22.6065L24.4207 11.1193C24.6548 10.8835 24.9732 10.7506 25.3055 10.75ZM25.3009 17.6036L27.2291 15.6891L25.3109 13.7709L23.4032 15.6923L25.3009 17.6036ZM21.6418 17.4664L23.5268 19.365L16.899 25.9455L14.5935 26.4066L15.0546 24.101L21.6418 17.4664ZM10.25 19.75H1.75V22.25H10.25V19.75ZM17.25 12.75H1.75V15.25H17.25V12.75Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLinesPencil);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
